import {
  publicServicesListResponseSchema,
  serviceCategoriesResponseSchema,
  type PublicService,
  type PublicServiceOption,
  type ServiceCategoriesResponse,
} from "@openings/api-contract";
import { BaseHttpClient, baseOk, type ApiOk } from "./base";

export type ServiceOptionDTO = PublicServiceOption;
export type ServiceDTO = PublicService;
export type ServiceCategoryDTO = ServiceCategoriesResponse["items"][number];

const listOk = baseOk(publicServicesListResponseSchema);
const categoriesOk = baseOk(serviceCategoriesResponseSchema);

export class ServicesClient extends BaseHttpClient {
  listBySalon(salonId: string): Promise<ApiOk<{ services: ServiceDTO[] }>> {
    const qs = new URLSearchParams({ salonId });
    return this.get<ApiOk<{ services: ServiceDTO[] }>>(
      `/v1/services?${qs.toString()}`,
      listOk,
    );
  }

  listCategories(salonId: string): Promise<ApiOk<ServiceCategoriesResponse>> {
    const qs = new URLSearchParams({ salonId });
    return this.get<ApiOk<ServiceCategoriesResponse>>(
      `/v1/services/categories?${qs.toString()}`,
      categoriesOk,
    );
  }
}
